var lib_core = require("lib-core");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var HeaderStraightGeneratorInteractionModel = require('./headerStraightGeneratorInteractionModel.js');

var HeaderStraightSocketGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    HeaderStraightGeneratorInteractionModel.apply(this, arguments);
};

lib_core.inherit(HeaderStraightSocketGeneratorInteractionModel, HeaderStraightGeneratorInteractionModel);
HeaderStraightSocketGeneratorInteractionModel.$class = 'HeaderStraightSocketGeneratorInteractionModel';
module.exports = HeaderStraightSocketGeneratorInteractionModel;

HeaderStraightSocketGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var tailLength = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('terminalTailLength', 'Terminal Tail Length'), true, null, false, this.terminalTailLength, this.userSettingsModel.distanceUnit);
    return [tailLength];
};